import { IconProp } from '@fortawesome/fontawesome-svg-core';
import {
  faHeart,
  faHome,
  faMapMarker,
  faShoppingCart,
  faStar,
  faUser,
  faUsers
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useQuery } from '@tanstack/react-query';
import {
  FaqsItems,
  getAllByVendorId,
  getAllProductByVendor,
  getVendorProductReviewsByVendorId,
  ProductReviewDetail,
  vendorProductReviewList,
  VendorProducts
} from 'api/products/_requests';
import EcomProfileAddressInfo from 'components/forms/EcomProfileAddressInfo';
import EcomProfilePersonalInfo from 'components/forms/EcomProfilePersonalInfo';
import EcomVendorDetailAddressInfo from 'components/forms/EcomVendorDetailAddressInfo';
import EcomVendorPersonalInfo from 'components/forms/EcomVendorPersonalInfo';
import EcomVerndorDetailInfo from 'components/forms/EcomVerndorDetailInfo';
import EComCustomerOrdersTable from 'components/tables/EComCustomerOrdersTable';
import EcomFaqsVendor from 'components/tables/EcomFaqsVendor';
import EcomProfileOrdersTable from 'components/tables/EcomProfileOrdersTable';
import EcomProfileReviewsTable from 'components/tables/EcomProfileReviewsTable';
import EcomProfileStoresTable from 'components/tables/EcomProfileStoresTable';
import EcomVendorBrandProductReviewsTable from 'components/tables/EcomVendorBrandProductReviewsTable';
import EcomVendorDetialReviewsTable from 'components/tables/EcomVendorDetialReviewsTable';
import EcomVendorListProductTable from 'components/tables/EcomVendorListProductTable';
import EcomWishlistTable from 'components/tables/EcomWishlistTable';
import { PF } from 'helpers/utils';
import { useEffect, useState } from 'react';
import { Nav, Tab } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { RootState } from 'redux-state/store';

interface TabLink {
  id: string;
  label: string;
  number?: number;
  icon: IconProp;
  content: (vendorId?: string) => JSX.Element;
  role?: 'customer' | 'vendor' | 'both';
}

const VendorDetailsTabs = ({ vendorId }: { vendorId?: string }) => {
  const [productsData, setProductsData] = useState<VendorProducts[]>([]);
  const { data: vendorproductReviews } = useQuery<vendorProductReviewList>({
    queryKey: ['vendorproductReview-by-vendor', vendorId],
    queryFn: () => getVendorProductReviewsByVendorId(vendorId!),
    enabled: !!vendorId
  });

  const { data: vendorFaqs } = useQuery<FaqsItems[]>({
    queryKey: ['faqs-by-vendor', vendorId],
    queryFn: () => getAllByVendorId(vendorId!),
    enabled: !!vendorId
  });

  const fetchProductsData = async () => {
    try {
      const response = await getAllProductByVendor(vendorId!);
      const temp = response.map((item: VendorProducts) => ({
        ...item,
        thumbnail:
          PF + (item.thumbnail !== undefined ? item.thumbnail : 'goods')
      }));

      setProductsData(temp);
    } catch (error) {
      console.error('Failed to fetch products:', error);
    }
  };
  useEffect(() => {
    fetchProductsData();
  }, []);

  const tabLinks: TabLink[] = [
    {
      id: 'products',
      label: 'Products',
      icon: faShoppingCart,
      number: productsData?.length ?? 0,
      content: vendorId => (
        <EcomVendorListProductTable productsData={productsData ?? []} />
      ),
      role: 'both'
    },
    {
      id: 'vendorreview',
      label: 'Vendor Reviews',
      number: vendorproductReviews?.vendorsReviews?.length ?? 0,
      icon: faStar,
      content: vendorId => (
        <EcomVendorDetialReviewsTable
          vendorReviews={vendorproductReviews?.vendorsReviews ?? []}
        />
      ),
      role: 'both'
    },
    {
      id: 'review',
      label: 'Product Reviews',
      number: vendorproductReviews?.productReviews?.length ?? 0,
      icon: faStar,
      content: vendorId => (
        <EcomVendorBrandProductReviewsTable
          vendorbrandproductReviews={vendorproductReviews?.productReviews ?? []}
        />
      ),
      role: 'both'
    },
    {
      id: 'faqs',
      label: 'FAQS',
      number: vendorFaqs?.length ?? 0,
      icon: faStar,
      content: vendorId => (
        <EcomFaqsVendor
          vendorFaqs={vendorFaqs ?? []}
          vendorId={vendorId ?? ''}
        />
      ),
      role: 'both'
    },
    {
      id: 'personal-info',
      label: 'Personal info',
      icon: faUser,
      content: vendorId => <EcomVerndorDetailInfo vendorId={vendorId} />,
      role: 'both'
    },
    {
      id: 'address',
      label: 'Address',
      icon: faMapMarker,
      content: vendorId => <EcomVendorDetailAddressInfo vendorId={vendorId} />,
      role: 'both'
    }
  ];

  return (
    <Tab.Container defaultActiveKey="products">
      <Nav className="mb-3 pb-1 gap-3 nav-underline flex-nowrap scrollbar">
        {tabLinks.map(item => (
          <Nav.Item key={item.id}>
            <Nav.Link eventKey={item.id} className="text-nowrap">
              <FontAwesomeIcon icon={item.icon} className="me-2" />
              {item.label}{' '}
              {item.number && (
                <span className="text-body-tertiary fw-normal">
                  ({item.number})
                </span>
              )}
            </Nav.Link>
          </Nav.Item>
        ))}
      </Nav>

      <Tab.Content>
        {tabLinks.map(item => (
          <Tab.Pane
            key={item.id}
            eventKey={item.id}
            // title={
            //   <>
            //     <FontAwesomeIcon icon={item.icon} className="me-2" />
            //     {item.label}{' '}
            //     {item.number && (
            //       <span className="text-body-tertiary fw-normal">({item.number})</span>
            //     )}
            //   </>
            // }
          >
            {item?.content(vendorId)}
          </Tab.Pane>
        ))}
      </Tab.Content>
    </Tab.Container>
  );
};

export default VendorDetailsTabs;
